'use client';

import { useState, useEffect } from 'react';

interface ScrollProgressIndicatorProps {
  className?: string;
}

const ScrollProgressIndicator = ({ className = '' }: ScrollProgressIndicatorProps) => {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.scrollY;
      const scrollableHeight = documentHeight - windowHeight;
      const progress = (scrollTop / scrollableHeight) * 100;
      
      setScrollProgress(Math.min(progress, 100));
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div data-component-id="src/components/common/ScrollProgressIndicator.tsx:30:4" data-component-path="src/components/common/ScrollProgressIndicator.tsx" data-component-line="30" data-component-end-line="41" data-component-file="ScrollProgressIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
      className={`fixed top-20 left-0 right-0 h-1 bg-primary/20 z-header ${className}`}
      role="progressbar"
      aria-valuenow={Math.round(scrollProgress)}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div data-component-id="src/components/common/ScrollProgressIndicator.tsx:37:6" data-component-path="src/components/common/ScrollProgressIndicator.tsx" data-component-line="37" data-component-end-line="40" data-component-file="ScrollProgressIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-full%20bg-accent%20transition-all%20duration-200%20ease-out%22%7D"
        className="h-full bg-accent transition-all duration-200 ease-out"
        style={{ width: `${scrollProgress}%` }}
      />
    </div>
  );
};

export default ScrollProgressIndicator;